export const getStartTime = (time: string) => time?.slice(0, 8);

export const getEndTime = (time: string) => time?.slice(-8);
